import React from 'react';
import type { TrustBoxProps } from './types';

export const TrustBoxMicroReviewCount: React.FC<TrustBoxProps> = ({
  ref,
  theme,
  clickable,
  ...rest
}) => (
  <div
    ref={ref}
    style={clickable ? {} : { pointerEvents: 'none', userSelect: 'none' }}
    className="trustpilot-widget"
    data-locale="it-IT"
    data-template-id="5419b6a8b0d04a076446a9ad"
    data-businessunit-id="5cacae5d7b08650001e13ded"
    data-style-height="48px"
    data-style-width="100%"
    data-theme={theme}
    {...rest}
  />
);
